/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Scope_Profile_Read_DescInputs */



/**
* | output |
* | --- |
* | "Read basic profile (roles, VEKN ID)" |
*
* @param {Developer_Scope_Profile_Read_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_scope_profile_read_desc = /** @type {((inputs?: Developer_Scope_Profile_Read_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Scope_Profile_Read_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire le profil de base (rôles, VEKN ID)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leer perfil básico (roles, ID VEKN)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ler perfil básico (funções, VEKN ID)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leggi profilo base (ruoli, VEKN ID)")
	return /** @type {LocalizedString} */ ("Read basic profile (roles, VEKN ID)")
});